import gql from "graphql-tag";

export default gql`

query postStayAnswerStatsGetAvailableMonths($hotelId: String!, $year: Float!) {
  postStayAnswerStatsGetAvailableMonths(hotelId: $hotelId, year: $year)
}


`